import React from 'react';
import './App.css';

import About from './components/About';
import Companies from './components/Companies';
import Contact from './components/Contact';
import Credentials from './components/Credentials';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import ValueProps from './components/ValueProps';
import WorkWithMe from './components/WorkWithMe';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Companies />
        <About />
        <ValueProps />
        <Services />
        <WorkWithMe />
        <Credentials />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
